import { atomWithStorage } from "jotai/utils";

export type DownloadedDocumentsState = {
	documents: string[];
};

const defaultState: DownloadedDocumentsState = {
	documents: [],
};

export const downloadedDocumentsState =
	atomWithStorage<DownloadedDocumentsState>(
		"MYPLANN_DOWNLOADED_DOCUMENTS_STATE",
		defaultState,
	);
